import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'moh-gzz-main-content',
  templateUrl: './gzz-main-content.component.html',
  styleUrls: ['./gzz-main-content.component.scss']
})
export class GzzMainContentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/general/gzz-main-content/gzz-main-content.component.ts